import React from 'react';
// @ts-ignore
import { Button } from '@els/els-react--button';
// @ts-ignore
import { Modal } from '@els/els-react--modal';
import './default-filter-confirmation-modal.scss';

const DefaultFilterConfirmationModal = (props: any) => {
    const {
        setIsModalOpen,
        handleAddDefaultFilters,
        favoriteFilters,
        selectedFilters,
    } = props;
    const modalbaseClassName = 'confirmation-modal';
    return (
        <Modal
            onClose={() => setIsModalOpen(false)}
            id="modal-id"
            type="neutral"
        >
            <div className={`${modalbaseClassName}`}>
                <div className={`${modalbaseClassName}__title-wrapper`}>
                    <h2>
                        {`Confirm ${
                            favoriteFilters !== ''
                                ? 'update to your'
                                : 'save as'
                        } default filters`}
                    </h2>
                </div>
                <div className={`${modalbaseClassName}__content-wrapper`}>
                    {favoriteFilters !== '' && (
                        <>
                            <p
                                className={`${modalbaseClassName}__content-wrapper__details`}
                            >
                                <b>Previous default filters: </b>
                                {Object.values(favoriteFilters).join(',')}
                            </p>
                            <p
                                className={`${modalbaseClassName}__content-wrapper__details`}
                            >
                                <b>New default filters: </b>
                                {Object.values(selectedFilters).join(',')}
                            </p>
                        </>
                    )}
                    <p>
                        {`Do you want to save these ${
                            favoriteFilters !== '' && 'new'
                        } filters as your default
                        settings? You can change them anytime in the future.`}
                    </p>
                </div>
                <div className={`${modalbaseClassName}__button-wrapper`}>
                    <Button
                        type="secondary"
                        onClick={() => setIsModalOpen(false)}
                        className={`${modalbaseClassName}__button-wrapper-cancel`}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="primary"
                        onClick={() => handleAddDefaultFilters()}
                        className={`${modalbaseClassName}__button-wrapper-confirm`}
                    >
                        {`Yes, ${
                            favoriteFilters !== '' ? 'update' : 'save as'
                        } default filters`}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default DefaultFilterConfirmationModal;
